import type { ReactNode } from 'react'

/**
 * `p.note` → `note` (process/08-COMPONENT-CATALOGUE.md), block variant. font-size 11.5px →
 * --fs-body (+0.5px delta); line-height 1.55 → --lh-normal (-0.05 delta) — both the map's own
 * recorded tolerance, not a new deviation.
 *
 * `tone="onPanel"`: inside the prototype's own `.gpanel` (`settings-panel`), `.gpanel p{color:
 * var(--tx2)}` outranks the bare `.note{color:var(--muted)}` on specificity (class+tag beats
 * class alone), so every `<p class="note">` inside a settings panel renders darker (`--tx2`) than
 * `.note` elsewhere in the app (`--muted`) — found by the semantic-diff color check, confirmed by
 * reading the prototype's own cascade rather than assumed. Pass this on any `Note` nested inside a
 * `settings-panel`/`settings-panel-body`/`settings-panel-rail`.
 */
export function Note({ children, tone = 'muted' }: { children: ReactNode; tone?: 'muted' | 'onPanel' }) {
  return (
    <p data-cmp="note" className={`text-body leading-normal ${tone === 'onPanel' ? 'text-tx2' : 'text-muted'}`}>
      {children}
    </p>
  )
}
